/*
 * @Author: 陈朝晖
 * @Date: 2022-07-05 11:09:02
 * @LastEditTime: 2022-07-05 18:20:58
 * @Description: storage占用的key 这里没区分是sessionStorage 还是localStorage 这个用的地方比较多 都拉出来统一管理了
 */
export const STORAGE_KEYS = {
  // 购物车
  cart: "dzerpcar",
  // 购物车用户
  cartCusomer: "dzerpcarCusomer",
  // 合约交易购物车
  agreementCart: "dzerpcarAgreement",
  prevOffers: "dzerpprevOffers",
};
